import React from 'react'
import { AutocompleteAjaxSeeker, IconSeeker } from "@ui-seeker/core"
import { multipleModalIds, multipleUsersModalOption } from "Pages/Admin/Users/@signals"
import { Grid } from "@mui/material"
import { AppAsyncOfficesAutocomplete, AppBulkEditAction, AppDialogCancel, AppModal, AppSitesAutocomplete } from "@components"
import { BACKEND_APIS } from "@constants"
import { batch } from "@preact/signals-react"
import { USER_MULTI_OPTIONS } from "Pages/Admin/Users/@constans"
import { useEditUsersModal } from "Pages/Admin/Users/@hooks"


export default function MultipleUsersModal() {

	const { handleSubmit, selectorData, setSelectorData, isSubmitLoading, modalPayload } = useEditUsersModal()

	if (!multipleModalIds.value.length || !multipleUsersModalOption.value) return null

	const onClose = () => batch(() => {
		multipleModalIds.value = []
		multipleUsersModalOption.value = null
		setSelectorData([])
	})

	return <AppModal
		hideActions
		icon="users-gear"
		title="Edit multiple users offices/sites"
		subtitle={`${multipleModalIds.value.length} user${multipleModalIds.value.length === 1 ? '' : 's'} selected`}
		controller={onClose}
		isOpen={!!multipleModalIds.value.length && !!multipleUsersModalOption.value}
		footer={<>
			<AppDialogCancel onClick={onClose}/>
			<AppBulkEditAction
				danger
				loading={isSubmitLoading}
				startIcon={<IconSeeker icon="trash-can"/>}
				onClick={() => handleSubmit(modalPayload, `${BACKEND_APIS.USER}/remove-multi`)}
				disabled={!selectorData.length}
			>
				Confirm Deletion
			</AppBulkEditAction>
			<AppBulkEditAction
				loading={isSubmitLoading}
				onClick={() => handleSubmit(modalPayload, `${BACKEND_APIS.USER}/add-multi`)}
				startIcon={<IconSeeker icon="pen"/>}
				disabled={!selectorData.length}
			>
				Confirm Edition
			</AppBulkEditAction>
		</>}
	>

		<Grid container spacing={2}>
			{multipleUsersModalOption.value === USER_MULTI_OPTIONS.SITE && <Grid item xs={12} sx={{ my: 1 }}>
				<AppSitesAutocomplete
					multiple
					urlAjax={`${BACKEND_APIS.MASTER_DATA}/admin/options/sites`}
					value={selectorData}
					onChange={e => setSelectorData(e.target.value)}
				/>
			</Grid>}
			{multipleUsersModalOption.value === USER_MULTI_OPTIONS.OFFICE && <Grid item xs={12} sx={{ my: 1 }}>
				<AppAsyncOfficesAutocomplete
					multiple
					urlAjax={`${BACKEND_APIS.MASTER_DATA}/admin/options/offices`}
					value={selectorData}
					onChange={e => setSelectorData(e.target.value)}
				/>
			</Grid>}
			{multipleUsersModalOption.value === USER_MULTI_OPTIONS.MASTERS && <Grid item xs={12} sx={{ my: 1 }}>
				<AutocompleteAjaxSeeker
		filterSelectedOptions={false} 
					multiple
					useLoading
					urlAjax={`${BACKEND_APIS.MASTER_DATA}/admin/options/master-users`}
					placeholder="Masters"
					value={selectorData}
					onChange={e => setSelectorData(e.target.value)}
				/>
			</Grid>}
		</Grid>

	</AppModal>
}